<div class="header">
  <div class="header-body">
    <div class="row align-items-center">
      <div class="col">
        <h1 class="header-title text-truncate mb-1 UWSlim">
          {{ title() }}
        </h1>
        @if (subTitle(); as subTitle) {
          <span>
            {{ subTitle }} <br>
          </span>
        }

        <a backButton style="cursor: pointer;" class="tiny">
          <i class="far fa-chevron-left mr-1"></i>{{ "nav.back" | translate }}
        </a>
      </div>
      <!--
      <div class="col-auto">
        <a href="#" class="text-msi-02 small">
          <i class="fal fa-user-plus mr-1"></i>Add new employee
        </a>
      </div>
      -->
    </div> <!-- / .row -->
  </div>
</div>
